import { ItemLevel, Layout } from "../helpers";

export const canUngroupSelection = (selectedAssets: any[], layout: Layout): boolean => {
  if (selectedAssets.length !== 1) {
    return false;
  }

  const path = selectedAssets[0].split('-');

  if (path.length !== 1) {
    return false;
  }

  const selectedItem = layout[path];

  if (!selectedItem) {
    return false;
  }

  return selectedItem.level === ItemLevel.GROUP;
};
